module.exports = __webpack_public_path__ + "img/gp_promotion_female_1.6253d7ef.png";